export default __webpack_public_path__ + "static/media/PotionIcon.6cd770f4.svg";